<template lang="pug">
  v-app(id="App")  
    v-toolbar(app flat prominent extended class="toolbar" :height="toolbarHeight")
      v-flex(xs1)        
      v-flex(xs9 sm9 md5 lg6 xl7)
        a(href="./")          
          img(v-if="scrolled" :src="logoImg" class="logo_scrolled")
          img(v-else :src="logoImg" class="logo")
      v-flex(xs1 sm1 md5 lg4 xl3)
        v-toolbar-items(id="toolb" class="hidden-sm-and-down" v-show="$vuetify.breakpoint.sm")
          //-v-toolbar-items(v-else id="toolb && $vuetify.breakpoint.sm" class="toolbar-items hidden-sm-and-down" v-show="$vuetify.breakpoint.sm")
          v-btn(flat class="dropdown_btn" @click.native="expand=!expand")
            v-icon(dark) dehaze

          div(v-show="expand")
            v-list(class="dropdown_lst")
              v-list-tile
                a(href="./")
                  img(src="./assets/logo_lsr.png" class="logo_mnu")
              br
              v-list-tile(class="dropdown_lst_items" v-for="item in menu" :key="item.id" :href="item.href" :target="item.target" @click.native="onChangeComponent(item.comp)")
                v-list-tile-content
                  v-list-tile-title {{ item.title }}

        //-v-toolbar-items(class="toolbar-items hidden-sm-and-down")      
        v-toolbar-items(v-if="scrolled" class="toolbar-items_scrolled hidden-sm-and-down" v-show="$vuetify.breakpoint.md")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}      
        v-toolbar-items(v-else class="toolbar-items hidden-sm-and-down" v-show="$vuetify.breakpoint.md")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}      

        v-toolbar-items(v-if="scrolled" class="toolbar-items_scrolled hidden-sm-and-down" v-show="$vuetify.breakpoint.lg")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}        
        v-toolbar-items(v-else class="toolbar-items hidden-sm-and-down" v-show="$vuetify.breakpoint.lg")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}

        v-toolbar-items(v-if="scrolled" class="toolbar-items_scrolled hidden-sm-and-down" v-show="$vuetify.breakpoint.xl")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}        
        v-toolbar-items(v-else class="toolbar-items hidden-sm-and-down" v-show="$vuetify.breakpoint.xl")
          v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}


        //- v-toolbar-items(v-if="scrolled" class="toolbar-items_scrolled hidden-sm-and-down" v-show="$vuetify.breakpoint.md")
        //-   v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}      
        //- v-toolbar-items(v-else class="toolbar-items hidden-sm-and-down" v-show="$vuetify.breakpoint.md")
        //-   v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="menu") {{ item.title }}      


        v-menu(class="hidden-md-and-up" v-show="$vuetify.breakpoint.xs")
          v-toolbar-side-icon(slot="activator")
          v-list
            v-list-tile(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" :target="item.target")
              v-list-tile-content
                v-btn(flat class="menu") {{ item.title }}        
                //-v-list-tile-title {{ item.title }}
        
        //- v-menu(light nudge-width="1000" max-height="300px" class="hidden-md-and-up" v-show="$vuetify.breakpoint.sm")
        //-   v-btn(flat class="dropdown_btn" slot="activator")
        //-     v-icon(dark) dehaze
        //-   //- template(v-slot:activator="{ on }")
        //-   //-   v-toolbar-title(v-on="on")
        //-   //-     span
        //-   //-     v-icon(dark) dehaze

        //-   v-list(class="dropdown_lst")
        //-     v-list-tile
        //-       img(src="./assets/logo_lsr.png" class="logo_mnu")
        //-     br
        //-     v-list-tile(class="dropdown_lst_items" v-for="item in menu" :key="item.id" :href="item.href" :target="item.target" @click.native="onChangeComponent(item.comp)")
        //-       v-list-tile-content
        //-         v-list-tile-title {{ item.title }}
        //-     //- v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" flat class="dropdown_btn") {{ item.title }}      
            
      v-flex(xs1)
    component(:is='currentView' @change-component="onChangeComponent" v-on:onChangeComponent="onChangeComponent" v-on:onChangeArea="onChangeArea" v-bind:Area="Area")    

    //- v-footer(class="footer")
    //-   v-flex(xs12)
    //-     v-layout(justify-center row wrap)
    //-       v-layout(justify-center row wrap)
    //-         v-btn(v-for="item in menu" :key="item.id" @click.native="onChangeComponent(item.comp)" class="footerlinks") {{ item.title }}
    //-     v-layout(justify-center row wrap)
    //-     v-layout(justify-center row wrap)
    //-       v-flex(xs1)
    //-       v-flex(xs3)
    //-         v-layout(justify-center row wrap)        
    //-           p
    //-           br
    //-           p(class="texto_fundo2") </br></br></br>© 2019 Luis S. Rodrigues & Associados. All Rights Reserved.      
    //-       v-flex(xs8)

</template>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<script>
import apresentacao from './components/apresentacao'
import areas_actividade from './components/areas_actividade'
import advogados from './components/advogados'
import contactos from './components/contactos'

export default {
  name: 'App',
  components: {
    apresentacao,
    areas_actividade,
    advogados,
    contactos    
  },
  data () {
    return {
      logoImg: require('./assets/logo_lsr.png'),
      toolbarHeight: 66,
      scrolled: false,
      currentView: apresentacao,
      expand: false,
      menu: [    
        { id: '1', title: 'Apresentação', comp: 'apresentacao'},
        { id: '2', title: 'Áreas de Actividade', comp: 'areas_actividade'},
        { id: '3', title: 'Advogados', comp: 'advogados'},
        { id: '4', title: 'Contactos', comp: 'contactos'}         
      ],
      Area: 1,

    }
  },
 
  methods: {
    onChangeComponent(comp){
      if (comp === "apresentacao")
        this.currentView = apresentacao
      if (comp === "areas_actividade")
        this.currentView = areas_actividade
      if (comp === "advogados")
        this.currentView = advogados
      if (comp === "contactos")
        this.currentView = contactos  
      this.expand=false              
    },
    onChangeArea(area){
        this.Area = area
        this.currentView = areas_actividade
    },
    goScroll(){
      if(window.scrollY > 80){
          //this.logoImg = require('./assets/logo_LSRAssociados.png')
          this.logoImg = require('./assets/lsr_text.svg')
          this.toolbarHeight = 44
          this.scrolled = true
      }else{
          this.logoImg = require('./assets/logo_lsr.png')
          this.toolbarHeight = 66
          this.scrolled = false
      }
    },          
    scrolledOn: function (){
      return this.scrolled && $vuetify.breakpoint.sm
    }

   },
  
  created(){
    //this.$validator.localize('pt')
    //this.$validator.localize('es')
    //this.$validator.localize('en')
    //this.$validator.localize('fr')
    //this.$validator.localize('cn')
    let userLang = navigator.language || navigator.userLanguage;
    this.$validator.localize(userLang)    
    window.addEventListener('scroll', this.goScroll)
  },
  destroyed(){
    window.removeEventListener('scroll', this.goScroll)
  },
  mounted() {

  },

}
</script>

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
<style lang="stylus">
@import './app.styl'
</style>